
import React from "react";
import blog1 from '../assets/img/blog/blog1.jpg';
import blog2 from '../assets/img/blog/blog2.jpg';
import blog3 from '../assets/img/blog/blog3.jpg';
import blog4 from '../assets/img/blog/blog4.jpg';
import blog5 from '../assets/img/blog/blog5.jpg';
import Icon1 from "../assets/img/calendar.svg";
import Icon2 from "../assets/img/user.svg";

const LatestPost = () => {
  const posts = [
    {
      title: "5 Common Mistakes Businesses Make When Ordering Uniforms",
      date: "Jan 4, 2024",
      img: blog1,
    },
    {
      title: "How Hotel Uniforms Shape Guest Perceptions and First Impressions",
      date: "Jan 4, 2024",
      img: blog2,
    },
    {
      title: "The Role of Uniforms in the Healthcare Industry: Balancing Comfort and Hygiene",
      date: "Jan 4, 2024",
      img: blog3,
    },
  ];

  return (
    <div className="latest_post">
      <h4>Latest Post</h4>
      {posts.map((post, index) => (
        <div
          className="latest_post_1"
          key={index}
          style={index === posts.length - 1 ? { border: "none" } : {}}
        >
          <img className="blog-1" src={post.img} alt={post.title} title={post.title} />
          <div className="latest_post-detail">
            <p>{post.title}</p>
            <div className="admin">
              <img src={Icon1} alt="icon" />
              <p>{post.date}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LatestPost;
